export default "{\n    \"languageSelectPlaceholder\": \"Sélectionner la langue préférée\",\n    \"languageSelectLabel\": \"Langue\"\n}\n"